import { useState } from 'react';
import { Button, List, Tooltip } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { formatDateTime } from 'shared/utils/time/format-date-time.ts';
import { useGetCargoDocuments } from 'client-app/api/documents/use-get-cargo-documents';
import { DocumentListItem } from 'client-app/components/documents/document-list-item/document-list-item.tsx';
import { DocumentsModal } from 'client-app/components/documents/documents-modal/documents-modal.tsx';
import type { IDocumentsListModalProps } from './types';

export const DocumentsListModal: React.FC<IDocumentsListModalProps> = ({ cargoId }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { data: documents, isLoading } = useGetCargoDocuments(cargoId, { enabled: isModalOpen });
  const toggleModalStatus = () => setIsModalOpen((prevState) => !prevState);

  return (
    <>
      <Tooltip title='Documents' placement='bottom'>
        <Button icon={<FileTextOutlined />} onClick={toggleModalStatus} />
      </Tooltip>
      <DocumentsModal
        isModalOpen={isModalOpen}
        isLoading={isLoading}
        documentsAvailable={!!documents?.length}
        title='Documents'
        onClose={toggleModalStatus}>
        <List
          size='small'
          itemLayout='horizontal'
          dataSource={documents}
          renderItem={(document) => (
            <DocumentListItem
              key={document.id}
              document={document}
              description={<span>{formatDateTime(document.createdAt)}</span>}
            />
          )}
        />
      </DocumentsModal>
    </>
  );
};
